import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class CountryStateService {
  private countryIdSubject = new BehaviorSubject<string | null>(null);
  public countryId$ = this.countryIdSubject.asObservable();

  constructor() {
    console.log(
      "🏪 CountryStateService Constructor called at",
      new Date().toISOString(),
    );
    console.log(
      "🏪 Initial BehaviorSubject value:",
      this.countryIdSubject.value,
    );

    // Debug: Log every emission
    this.countryId$.subscribe((value) => {
      console.log(
        "🏪 CountryStateService emitting:",
        value,
        "at",
        new Date().toISOString(),
      );
      console.trace("🏪 Emission call stack:");
    });
  }

  emitCountryId(countryId: string | null) {
    console.log(
      "🏪 emitCountryId called with:",
      countryId,
      "at",
      new Date().toISOString(),
    );
    console.trace("🏪 emitCountryId call stack:");
    this.countryIdSubject.next(countryId);
  }

  getCurrentCountryId(): string | null {
    const current = this.countryIdSubject.value;
    console.log("🏪 getCurrentCountryId returning:", current);
    return current;
  }
}
